var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"db0c0f9a366a115117b53b3ad0125c27a827e999"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["sprout@sprout-place"]={id:"db0c0f9a366a115117b53b3ad0125c27a827e999"};
      